module.exports = __webpack_public_path__ + "img/menu.bac1e784.svg";